import { FONT, PALETTE_LIGHT, mediaMinWidth, styled } from "@dexibit/styles";

import {
  MOBILE_BAR_HEIGHT,
  NAV_WIDTH_COLLAPSED,
} from "./components/Navigation/constants";

export const AppGrid = styled("div")`
  font-family: ${FONT.BODY_REGULAR.fontFamily};
  font-size: ${FONT.BODY_REGULAR.fontSize};
  color: ${PALETTE_LIGHT.TEXT_EMPHASIS_REGULAR};
  display: grid;
  height: 100dvh;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: 1fr;
  grid-template-areas: "main-content";
  /* minmax(0, 1fr) so the row can shrink below its content's natural size.
     Needed now that the native /ask route renders DE's ChatLayout directly
     inside the grid — without this the conversation list's intrinsic height
     would grow the row past the viewport. */
  grid-template-rows: minmax(0, 1fr);
  padding-top: ${MOBILE_BAR_HEIGHT}px;

  &.has-mega-header {
    grid-template-areas:
      "mega-header"
      "main-content";
    grid-template-rows: auto minmax(0, 1fr);
  }

  ${mediaMinWidth.tablet(`
    grid-template-columns: ${NAV_WIDTH_COLLAPSED}px 1fr;
    grid-template-areas: "navigation main-content";
    padding-top: 0;

    &.has-mega-header {
      grid-template-areas:
        "mega-header mega-header"
        "navigation main-content";
      grid-template-rows: auto minmax(0, 1fr);
    }
  `)}
`;

export const MegaHeaderArea = styled("div")`
  grid-area: mega-header;
`;

export const NavigationArea = styled("div")`
  display: contents;

  ${mediaMinWidth.tablet(`
    grid-area: navigation;
    display: block;
  `)}
`;

export const MainContentArea = styled("div")`
  grid-area: main-content;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
`;

export const AppContent = styled("section")`
  background-color: ${PALETTE_LIGHT.SURFACE_TEXTURE};
  flex: 1;
  display: flex;
  /* Needed for native routes like /ask whose content uses height: 100% —
     without this the flex item's default min-height: auto lets the child's
     intrinsic height expand AppContent past the grid row. */
  min-height: 0;
`;

export const LoadingContainer = styled("div")`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorContainer = styled("div")`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledIframe = styled("iframe")`
  width: 100%;
  height: 100%;
  border: none;
`;

export const Styled404Container = styled("div")`
  width: 100%;
  height: 100%;
  border: none;
`;
